import groupBy from "lodash/groupBy";
import chunk from "lodash/chunk";

export default function (settings, groups = [], columns = 4) {

    settings = settings.filter(item => groups.includes(item.group))
    settings = groupBy(settings, (item) => item.group)

    Object.keys(settings).map(group => {
        settings[group].sort((a, b) => {
            return a.name.localeCompare(b.name);
        });

        if (columns > 1) {
            settings[group] = chunk(settings[group], columns)
        }
    })

    // Sort groups by name.
    settings = Object.keys(settings)
        .sort()
        .reduce((acc, key) => {
            acc[key] = settings[key]
            return acc;
        }, {})

    return settings
}
